module.exports = __webpack_public_path__ + "static/media/728x90_0014_en.33d0cedb.jpg";